import React, { useEffect, useState, lazy, Suspense } from "react";
import { AppUtilsProvider, RestServiceProvider } from "providers";
import { DEFAULT_TECHNICAL_ERROR_MESSAGE, DEFAULT_TECHNICAL_ERROR_TITLE } from "utils/constants";
import ErrorIcon from "images/error.svg";
import AppSpinner  from "ui/common-components/app-spinner"; // Assuming AppSpinner is available here




function App() {
  const [appData, setAppData] = useState({
    currentMsisdn: "",
    iMsisdn: "",
    successTextUrl: {},
    declineTextUrl: {},
    headerData: {},
    bannerFlag: false,
    productCatalog: null,
    contentOverrideMessage: "",
    defaultError: {
      display: false,
      title: "",
      messages: "",
      primaryButtonText: "",
      primaryButtonClickHandler: null,
      iconUrl: null,
    },
    spinnerFlag: true, // Start with spinner active
    redirectPartnerUrl: false,
  });

  // State to hold the dynamically loaded MainPage component
  const [MainPage, setMainPage] = useState(null);

  const updateAppData = (newData) => {
    setAppData((prevData) => ({ ...prevData, ...newData }));
  };
  
  useEffect(() => {
    const getInitialData = async () => {
      // The spinner is already active from the initial state
      const productCatalog = await RestServiceProvider.getProductCatalog();

      // --- STEP 3: Handle API errors ---
      if (!productCatalog.ok || !productCatalog.result?.result?.success) {
        // Load default UI in case of an error to avoid a blank screen
        setMainPage(lazy(() => import("ui/mainpage").then(module => ({ default: module.MainPage }))));
        updateAppData({
          defaultError: {
            display: true,
            title: DEFAULT_TECHNICAL_ERROR_TITLE,
            messages: DEFAULT_TECHNICAL_ERROR_MESSAGE,
            primaryButtonText: "Close",
            primaryButtonClickHandler: AppUtilsProvider.handleCloseATB,
            iconUrl: ErrorIcon,
          },
          spinnerFlag: false,
        });
        return;
      }

      const catalogResult = productCatalog.result.result;

      // --- STEP 4: Call the logic to load the correct UI ---
      //loadUIForPartner(catalogResult, setMainPage);
    setMainPage(lazy(() => import("ui-partner/mainpage").then(module => ({ default: module.MainPage }))));
      // --- STEP 5: Update the application state with the fetched data ---
      updateAppData({
        productCatalog: catalogResult,
        declineTextUrl: {
          Text: catalogResult.mslDetails.declinedmsg,
          Url: catalogResult.mslDetails["partner-redirect-url"],
        },
        headerData: {
          token: catalogResult.token,
          "client-txn-id": catalogResult["client-txn-id"],
        },
        bannerFlag: true,
        redirectPartnerUrl: catalogResult.mslDetails["partner-redirect-url"],
        spinnerFlag: false, // Hide spinner after data is ready
        defaultError: { display: false },
      });

      // --- STEP 6: Inject any external scripts needed ---
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.innerHTML = catalogResult["EvScript"]["s"];
      document.head.appendChild(script);
      document.dispatchEvent(new Event("DCBProtectRun"));
    };

    getInitialData();
  }, []);

  // Use the spinnerFlag as the single source of truth for the main loading state.
  // The Suspense fallback will handle the brief moment of loading the component code.
  if (appData.spinnerFlag || !MainPage) {
    return <AppSpinner />;
  }

  return (
    <Suspense fallback={<AppSpinner />}>
      <MainPage
        data={appData}
        actions={{
          updateDefaultError: (error) => updateAppData({ defaultError: error }),
          updateProductCatalog: (catalog) => updateAppData({ productCatalog: catalog }),
          displayBanner: (flag) => updateAppData({ bannerFlag: flag }),
          displaySpinner: (flag) => updateAppData({ spinnerFlag: flag }),
          updateMsisdn: (msisdn) => updateAppData({ currentMsisdn: msisdn }),
          updateIMsisdn: (msisdn) => updateAppData({ iMsisdn: msisdn }),
          updateBanner: (flag) => updateAppData({ bannerFlag: flag }),
          updateSuccessTextUrl: (url) => updateAppData({ successTextUrl: url }),
          updateDeclineTextUrl: (url) => updateAppData({ declineTextUrl: url }),
          updateContentOverrideMessage: (message) => updateAppData({ contentOverrideMessage: message }),
        }}
      />
    </Suspense>
  );
}

export default App;
